
































































import { ITimeOffRequest, ITimeOffApprover, TimeOffStateEnum } from '@/models';
import Vue from 'vue';
import moment from 'moment';

export default Vue.extend({
  name: 'TimeOffApproverList',

  props: {
    timeOff: {
      type: Object as () => ITimeOffRequest,
      required: true
    }
  },
  data() {
    return {
      TimeOffStateEnum
    };
  },
  methods: {
    moment
  }
});
